import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import { LoginFormType } from 'src/components/AuthNew/types';
import type { SimpleInterpolation } from 'styled-components';
import styled from 'styled-components';

type Props = {
  loginFormType: LoginFormType;
  setLoginFormType: (formtype: LoginFormType) => void;
  loginFormCSS?: ReadonlyArray<SimpleInterpolation>;
};

export const SwitchFormButtons = ({
  loginFormType,
  setLoginFormType,
  loginFormCSS,
}: Props) => {
  const { t } = useTranslation();
  return (
    <BtnWrapper>
      <StyledButton
        $width="145px"
        $isActive={loginFormType === LoginFormType.Phone}
        $formType={loginFormType}
        $loginFormCSS={loginFormCSS}
        onClick={() => setLoginFormType(LoginFormType.Phone)}
      >
        {t('checkout.loginForm.switchFormButtons.phone')}
      </StyledButton>
      <StyledButton
        $width="72px"
        $isActive={loginFormType === LoginFormType.Email}
        $formType={loginFormType}
        $loginFormCSS={loginFormCSS}
        onClick={() => setLoginFormType(LoginFormType.Email)}
      >
        {t('checkout.loginForm.switchFormButtons.email')}
      </StyledButton>
    </BtnWrapper>
  );
};

const BtnWrapper = styled.div`
  display: flex;
  margin-top: 24px;
`;

const StyledButton = styled(Button)<{
  $isActive: boolean;
  $formType: LoginFormType;
  $width: string;
}>`
  ${(props) =>
    props.$isActive ? props.$loginFormCSS : 'background: transparent'};
  width: ${({ $width }) => $width};
  border-radius: 8px 8px 0px 0px;
  height: 40px;
  border: none;
  color: ${(props) => (props.$isActive ? '#17181A;' : 'auto')};
  ${(props) => (props.$isActive ? 'font-weight: 700' : '')};
  ${(props) => (props.$isActive ? 'font-size: 14px' : '')};

  &:hover {
    color: ${(props) => (props.$isActive ? '#17181A;' : 'auto')};
  }
`;
